import Backbone from 'backbone'
import _ from 'lodash'
import SelectColumnsForm from '../common/select-columns-form'
import template from './scorecard-structure-columns.hbs'

var ScorecardStructureNew = Backbone.View.extend({

	tagName: 'form',

	className: 'reports scorecard-structure margin-collapse',

	initialize: function(options) {
		this.columnsForm = new SelectColumnsForm(_.pick(this, ['el', 'model']))
	},

	_template: function() {
		return template()
	},

	render: function() {
		this.$el.html(this._template())
		this.columnsForm.render()
		return this
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.columnsForm], 'remove')
	}

})

export default ScorecardStructureNew

ScorecardStructureNew.__filename__ = 'reports/wizard/scorecard-structure/scorecard-structure-columns.js'
